import { put } from './requests'

const resourcePath = 'user_preferences'

export function updateUserPreference (userPreference) {
  return put(resourcePath, { userPreference })
}
